/* eslint-disable local-rules/no-dynamic-classname */
import "./IdealPaymentType.scss";
import { FormattedMessage } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";
import PictoRadio from "app/pages/.shared/PictoRadio";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const IdealPaymentType = ({ total, onIssuerSelect, idealIssuers = [] }) => {
	return (
		<div className="ideal-payment-type">
			<div className="ideal-payment-type__pay-amount">
				<FormattedMessage id="payment.pay.all" />
				<span>
					<Amount value={total} size="large" />
				</span>
			</div>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="ideal-payment-type__select-message"
			>
				<FormattedMessage id="payment.methods.ideal.select.bank" />
			</Typography>
			<div className="ideal-payment-type__banks">
				{idealIssuers.map(issuer => {
					//to use when xe have a problem with checked radio
					//const isBankSelected = values?.payment?.issuerId === issuer.id;
					return (
						<div className="ideal-payment-type__banks--item" key={`bank${issuer.id}`}>
							<PictoRadio
								name="payment.issuerId"
								id={issuer.id}
								value={issuer.id}
								toggle={() => {
									onIssuerSelect(issuer.id);
								}}
								icon={
									<i
										className={`icon icon--${issuer.name
											.toLowerCase()
											.replace(/ /g, "-")}`}
									/>
								}
								label={issuer.name}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

IdealPaymentType.propTypes = {
	total: PropTypes.number,
	onIssuerSelect: PropTypes.func,
	idealIssuers: PropTypes.array,
};

export default IdealPaymentType;
